const accordionSelector = '.js-simple-accordion';
const accordionItemTriggerSelector = '.js-simple-accordion-trigger';
const activeClass = 'is-active';

function initSimpleAccordionsEvents() {
  const accordions = document.querySelectorAll(accordionSelector);

  accordions.forEach((accordion) => {
    const triggers = accordion.querySelectorAll(accordionItemTriggerSelector);
    triggers.forEach((trigger, triggerIndex) => {
      trigger.addEventListener('click', () => {
        triggers.forEach((parentTrigger, parentTriggerIndex) => {
          // when clicking on the same accordion this will toggle it
          if (triggerIndex === parentTriggerIndex) {
            parentTrigger.parentElement.classList.toggle(activeClass);
            return;
          }

          // remove the active class from all other accordions
          parentTrigger.parentElement.classList.remove(activeClass);
        });
      });
    });
  });
}

export function initSimpleAccordions() {
  initSimpleAccordionsEvents();

  // In the theme editor if a section, that has an accordion, is reloaded
  // we init the accordions again
  document.addEventListener('shopify:section:load', () => {
    const sectionAccordions = event.target.querySelector(accordionSelector);

    if (sectionAccordions === null) return;

    initSimpleAccordionsEvents();
  });
}
